import { SimpleBadge } from '@/components/badges';
import { Role } from '@/components/badges/types';
import { WorkspaceUserWithRole } from '@/models/workspace';
import { ColumnDef } from '@tanstack/react-table';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type UserRoleCellProps = {
  roles: string[];
};

const UserRoleCell: FC<UserRoleCellProps> = ({ roles }) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col gap-1'>
      {roles.map((role) => (
        <SimpleBadge key={role} label={t(role.toLowerCase() as Role)} />
      ))}
    </div>
  );
};

const UserRoleHeader: FC = () => {
  const { t } = useTranslation();
  return <>{t('COMMON:role')}</>;
};

export const userRoleColumn: ColumnDef<WorkspaceUserWithRole> = {
  accessorKey: 'role',
  header: UserRoleHeader,
  cell: ({ row }) => <UserRoleCell roles={row.original.role} />,
  enableSorting: false,
};
